import React, { useEffect } from 'react'
import { useOutletContext, useSearchParams } from 'react-router'
import Loader from '@/modules/base/components/loader/loader'
import lang from '@/lang'
import { PublicAccessContextType } from '@/modules/layout/components/public-access-layout'

interface RegistrationRedirectProps {
  targetUrl: string
}

const RegistrationRedirect = ({ targetUrl }: RegistrationRedirectProps) => {
  const [searchParams] = useSearchParams()
  const outletContext = useOutletContext<PublicAccessContextType>()

  useEffect(() => {
    outletContext.setIsLoading(true)
    outletContext.setHideSidebar(true)

    const performRedirect = async() => {
      const url = new URL(targetUrl)
      searchParams.forEach((value, key) => {
        url.searchParams.set(key, value)
      })
      window.location.replace(url.toString())
    }

    performRedirect()
  }, [targetUrl, searchParams])

  return <Loader text={lang.generics.loading} />
}

export default RegistrationRedirect
